"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get SFTP_PGP_KEY_STATUSES () {
        return SFTP_PGP_KEY_STATUSES;
    },
    get SftpPgpKeyModel () {
        return SftpPgpKeyModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const SFTP_PGP_KEY_STATUSES = [
    "active",
    "disabled"
];
const SftpPgpKeyModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    /** Armored public key. Not secret — this is what the admin hands to their source system. */ public_key: _zod.z.string(),
    /** Hex-encoded AES-256-GCM ciphertext of the armored private key. */ private_key_ciphertext: _zod.z.string(),
    /** Hex-encoded initialization vector used to seal the private key. */ iv: _zod.z.string(),
    /** Hex-encoded GCM authentication tag used to seal the private key. */ auth_tag: _zod.z.string(),
    /** 1 for a company's first key, incremented on every rotation. */ key_version: _zod.z.number(),
    status: _zod.z.enum(SFTP_PGP_KEY_STATUSES),
    created_at: _zod.z.date(),
    disabled_at: _zod.z.date().or(_zod.z.null())
});
